import {writeFileXLSX, utils} from 'xlsx';

export const exportExcel = (data)=>{
    const newWB = utils.book_new();
    const newWS = utils.json_to_sheet(data);
    utils.book_append_sheet(newWB,newWS,"attendence");
    const today = new Date();
    const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    const time = today.getHours() + "-" + today.getMinutes();
    writeFileXLSX(newWB,`CAttend${date}-${time}.xlsx`);
}
